import { RowTextContainer, RowTextsColumn } from '../styled-components.js'

export const TableRowText = ({
  mainText = null,
  secondaryText = null,
  leadingComponent = null,
  ...props
}) => {
  return (
    <RowTextContainer {...props}>
      {leadingComponent}
      <RowTextsColumn>
        {mainText}
        {secondaryText}
      </RowTextsColumn>
    </RowTextContainer>
  )
}
